export default "__VITE_ASSET__DIVLvVa6__"